/**
 * "5 min ago" for a list, the full date in the tooltip (redesign stage 0/3, from Device Lab: spans are
 * said like a person — "21 days", not "25663 min" — and `toLocaleString()` on every row was a column of
 * long dates nobody reads).
 *
 * Pure, with the clock and the language passed in, so it is tested without a browser.
 */

const STEPS: [Intl.RelativeTimeFormatUnit, number][] = [
  ['second', 60], ['minute', 60], ['hour', 24], ['day', 7], ['week', 4.35], ['month', 12], ['year', Infinity],
]

export function ago(iso: string | null | undefined, now: number = Date.now(), lang?: string): string {
  if (!iso) return ''
  const at = Date.parse(iso)
  if (Number.isNaN(at)) return ''
  let value = (at - now) / 1000
  const fmt = new Intl.RelativeTimeFormat(lang ?? (typeof document !== 'undefined' ? document.documentElement.lang : 'en'),
                                          { numeric: 'auto', style: 'short' })
  for (const [unit, size] of STEPS) {
    if (Math.abs(value) < size) return fmt.format(Math.round(value), unit)
    value /= size
  }
  return ''
}

/** The full local date and time, for the tooltip behind `ago`. */
export function exactly(iso: string | null | undefined): string {
  if (!iso) return ''
  const at = new Date(iso)
  return Number.isNaN(at.getTime()) ? '' : at.toLocaleString()
}
